// src/components/landing/TopBar.jsx
import { Link } from 'react-router-dom';

const TopBar = () => {
    return (
        <div className="w-full bg-[#f4e2bb] border-b border-[#e7d4ab] px-4 sm:px-6 lg:px-8">
            <div className="max-w-[1440px] mx-auto min-h-10 py-2 flex items-center justify-center gap-3">
                <p className="text-xs sm:text-sm text-[#1f1f1f] text-center sm:text-left">
                    We are currently in early access beta.
                </p>
                <Link
                    to="/signup"
                    className="inline-flex items-center justify-center bg-[#171717] text-white text-xs sm:text-sm px-4 py-1.5 rounded-full hover:bg-black transition-colors"
                >
                    Try For Free
                </Link>
            </div>
        </div>
    );
};

export default TopBar;
